// extracted by mini-css-extract-plugin
export var caption = "figure-module--caption--cb231 typography-module--small--2877f";
export var root = "figure-module--root--0567e";